<template>
  <vue-dialog :dialog-data="dialogData">
    <div style="margin-bottom: 15px"
         v-html="`操作完成！本次共操作：${list.length} 个，成功： <span class='color-success'>${result.ok}</span> 个，失败： <span class='color-danger'>${result.fail}</span> 个 `"/>
    <p style="margin-bottom: 5px">
      <label>自定义名称：</label>
      <span class="color-primary">{{dialogData.name_x}}</span>
    </p>
    <p style="margin-bottom: 15px">
      <label>自定义型号：</label>
      <span class="color-primary">{{dialogData.model_x}}</span>
    </p>
    <vue-table :table-data="tableData" size="mini" auto-paging>
      <template slot="result" slot-scope="{row}">
        <span v-if="row.result.code === 0" class="color-success">成功</span>
        <span v-else class="color-danger">{{formatError(row.result)}}</span>
      </template>
    </vue-table>
    <div style="text-align: center;margin-top: 20px">
      <el-button style="width: 100px" size="small" type="primary" @click="$emit('finish')">确定</el-button>
    </div>
  </vue-dialog>
</template>

<script>
  export default {
    name: "CustomResult",
    props: {dialogData: Object},
    data() {
      return {
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "批次", property: "batch_no", position: "left", tooltip: true},
            {label: "SN", property: "sn", width: 190},
            {label: "操作结果", property: "result", width: 220, tooltip: true},
          ],
        },
        list: [],
        result: {},
      }
    },
    methods: {
      formatError(res) {
        let msg = res.msg || "";
        if (res.data) {
          msg += "，";
          if (res.data.detail) {
            msg += res.data.detail;
          } else {
            msg += res.data;
          }
        }
        return msg;
      },
    },
    created() {
      const {list, result} = this.dialogData;
      this.tableData.tableList = this.list = list;
      this.result = result;
    }
  }
</script>

<style scoped>

</style>
